import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, ReportStatus } from './index';

export type ReportCreateData = { id: string };

export type ReportCreateResponse = ReportCreateData

export interface ReportCreateBody {
  name: string;
  description: string;
  fileId: string | null;
  status: ReportStatus;
  tags?: { name: string, id?: string }[];
  tagIds?: string[];
  tagList?: string[];
}

export const reportCreate = (payload: ReportCreateBody): Action<ReportCreateBody> => ({
  type: actions.reportCreateTrigger.toString(),
  payload,
});

export const reportCreateClear = (): Action => ({
  type: actions.reportCreateClear.toString(),
});

export function* reportCreateRequestSaga({ payload }: Action<ReportCreateBody>) {
  // eslint-disable-next-line no-unused-expressions,@typescript-eslint/no-unused-expressions
  ({ payload });
  yield put({
    type: actions.reportCreateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.reportCreateError.toString(),
      payload: {
        message: 'ReportCreate: Parameters not passed.',
      },
    });

    return;
  }

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/reports`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<ReportCreateData, ReportCreateResponse>(
    response,
    actions.reportCreateSuccess.toString(),
    actions.reportCreateError.toString(),
    false,
    (reportCreateData) => reportCreateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.reportCreateTrigger.toString(),
    defaultProcessingSaga(
      reportCreateRequestSaga,
      {
        error: actions.reportCreateError.toString(),
        locationCancel: actions.reportCreateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.reportCreateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.reportCreateClear.toString(),
    // });
  });

  yield takeLatest(actions.reportCreateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.reportCreateErrorReset.toString(),
    });
  });
}
